import React from 'react';
import PropTypes from 'prop-types';
import { components } from 'react-select';
import { SelectSearchable } from '../../ds/components/select/SelectSearchable';
import styles from './selectStore.module.scss';

const Control = ({ children, ...props }) => (
  <components.Control {...props}>
    <span className={styles['span']}>Sucursal:</span> {children}
  </components.Control>
);

Control.propTypes = {
  children: PropTypes.node,
};

export const SelectStores = ({
  stores,
  onChange,
  placeholder = 'Elige una opción',
  name,
}) => {
  return (
    <SelectSearchable
      name={name}
      options={stores}
      onChange={onChange}
      placeholder={placeholder}
      components={{
        Control,
        IndicatorSeparator: null,
      }}
      classNames={{
        container: () => styles['select-store'],
        control: () => styles['control'],
        valueContainer: () => styles['value-container'],
        menu: () => styles['menu'],
      }}
    />
  );
};

SelectStores.propTypes = {
  stores: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        .isRequired,
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  name: PropTypes.string.isRequired,
};
